export enum OnboardingErrorType {
  InitialCrmFetch = "InitialCrmFetch",
  Save = "Save",
  Submit = "Submit",
  NdaFetch = "NdaFetch",
  StatusPolling = "StatusPolling",
  CountryValidationFetch = "CountryValidationFetch",
  GdkMiddlewareFetch = "GdkMiddlewareFetch",
  DeleteGameConcept = "DeleteGameConcept",
  PartnerCenterFileUpload = "PartnerCenterFileUpload",
}

export type OnboardingError = {
  code: number;
  type: OnboardingErrorType;
  name?: string;
  message?: string;
  stack?: string;
};

export enum OnboardingErrorMessage {
  default = "defaultErrorMessage",
  invalidUrl = "invalidUrlErrorMessage",
}

export enum OnboardingServerErrorType {
  Authentication = "Authentication",
  InitialCrmFetch = "InitialCrmFetch",
  SaveGameConcept = "SaveGameConcept",
  GetFullIdXboxResponse = "GetFullIdXboxResponse",
  GetFullPitchResponse = "GetFullPitchResponse",
  GetOnboardingStatus = "GetOnboardingStatus",
  Get5x5Token = "Get5x5Token",
  GDKMiddlewareRequest = "GDKMiddlewareRequest",
  FailedToCreateCRMEntity = "FailedToCreateCRMEntity",
  FailedToDeleteCRMEntity = "FailedToDeleteCRMEntity",
  FailedToGetCRMEntity = "FailedToGetCRMEntity",
  FailedToUpdateCRMEntity = "FailedToUpdateCRMEntity",
  FailedToFindLogicalCollectionName = "FailedToFindLogicalCollectionName",
  CVSError = "CVSError",
  NDAError = "NDAError",
  OVDFError = "OVDFError",
  PartnerCenterTokenError = "PartnerCenterTokenError",
  PartnerCenterError = "PartnerCenterError",
  PartnerCenterEnrollmentError = "PartnerCenterEnrollmentError",
  PartnerCenterFileUploadError = "PartnerCenterFileUploadError",
  PartnerCenterStudioNameLookupError = "PartnerCenterStudioNameLookupError",
  TLAError = "TLAError",
  RoleUpdateJobError = "RoleUpdateJobError",
  GetPaginatedConcepts = "GetPaginatedConcepts",
  AuthenticationError = "AuthenticationError",
  AccessToken = "AccessToken",
  FailedToGetAccessToken = "FailedToGetAccessToken",
  GetOptionSetChoices = "GetOptionSetChoices",
  FailedToFetchEntityDefinitions = "FailedToFetchEntityDefinitions",
  GetTrackingInfo = "GetTrackingInfo",
  UrlValidationError = "UrlValidationError",
  CreateContractError = "CreateContractError",
  OneVetApiError = "OneVetApiError",
  OneVetStatusError = "OneVetStatusError",
  OneVetVettingError = "OneVetVettingError",
}
